import NextImage from 'next/image';

import React from 'react';

import styled from 'styled-components';

import { formatDate } from '@utils/date';

import { Partner } from '@customTypes/Partner';
import { ReviewContentDto } from '@customTypes/Review';

type PartnerReviewCommentProps = {
  partner: Partner;
  partnerReview: ReviewContentDto | undefined;
};

const PartnerReviewComment = ({ partner, partnerReview }: PartnerReviewCommentProps) => {
  if (!partnerReview || !partnerReview.content || partnerReview.visibility === 'invisible') {
    return null;
  }

  return (
    <Wrapper>
      <div className={'profile-image'}>
        <NextImage
          src={partner.profile ?? '/svg/partner_profile_default.svg'}
          alt={partner.name ?? 'Partner'}
          width={32}
          height={32}
        />
      </div>
      <div className={'review-comment'}>
        <div className={'partner-name'}>
          <span>{partner.name}</span>
        </div>
        <div className={'comment'}>
          <span>{partnerReview.content}</span>
        </div>
        <div className={'date'}>
          <span>{formatDate(new Date(partnerReview.created_at), 'YYYY년 M월 D일(dd)')}</span>
        </div>
      </div>
    </Wrapper>
  );
};

export default PartnerReviewComment;

const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;

  .profile-image {
    img {
      border-radius: 50%;
      margin-right: 8px;
    }
  }

  .review-comment {
    flex: 1;
    padding: 12px 16px;
    border-radius: 6px;
    background-color: #f3f4f8;

    .partner-name {
      margin-bottom: 8px;

      span {
        color: #2e3035;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        word-break: break-word;
      }
    }

    .comment {
      margin-bottom: 8px;

      span {
        color: #2e3035;
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        word-break: break-word;
        white-space: pre-wrap;
      }
    }

    .date {
      span {
        color: #a3a7ae;
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
      }
    }
  }
`;
